import React, { useState } from 'react';
import './AdminLogin.scss';
import { FiLock, FiEye, FiEyeOff, FiAlertCircle } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const AdminChangePassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [focusedField, setFocusedField] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        
        if (!password || !confirmPassword) {
            setError('Vui lòng nhập đầy đủ thông tin mật khẩu.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Mật khẩu xác nhận không khớp.');
            return;
        }

        if (password.length < 6) {
            setError('Mật khẩu phải có ít nhất 6 ký tự.');
            return;
        }

        setLoading(true);
        try {
            // Giả lập API call
            await new Promise(resolve => setTimeout(resolve, 1500));
            setSuccess('Đổi mật khẩu thành công. Đang chuyển hướng...');
            setTimeout(() => {
                navigate('/admin/auth/login');
            }, 2000);
        } catch (err) {
            setError('Có lỗi xảy ra. Vui lòng thử lại.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            {/* Subtle background grid pattern */}
            <div className="admin-login-bg-grid" />

            {/* Animated border wrapper */}
            <div className="admin-login-border-wrapper">
                <div className="admin-login-border-glow" />
                <div className="admin-login-card">
                    {/* Brand Header */}
                    <div className="admin-login-brand">
                        <div className="admin-login-logo">
                            <img src={require('../../images/Logo/Logo HSV_Icon.jpg')} alt="HSV Logo" style={{ width: '48px', height: 'auto', objectFit: 'contain' }} />
                        </div>
                        <div className="admin-login-brand-text">
                            <span className="admin-login-brand-name">Healthcare Solution Việt Nam</span>
                            <span className="admin-login-brand-sub">Hệ Thống Quản Lý</span>
                        </div>
                    </div>

                    <div className="admin-login-divider" />

                    {/* Title */}
                    <div className="admin-login-header">
                        <h1 className="admin-login-title">Đổi Mật Khẩu</h1>
                        <p className="admin-login-subtitle">Vui lòng nhập mật khẩu mới của bạn</p>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="admin-login-error">
                            <FiAlertCircle className="admin-login-error-icon" />
                            <span>{error}</span>
                        </div>
                    )}

                    {/* Success Message */}
                    {success && (
                        <div className="admin-login-error" style={{ background: '#ecfdf5', color: '#059669', borderColor: '#a7f3d0' }}>
                            <span>{success}</span>
                        </div>
                    )}

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="admin-login-form" noValidate>
                        <div className={`admin-login-field ${focusedField === 'password' ? 'is-focused' : ''} ${password ? 'has-value' : ''}`}>
                            <label htmlFor="al-password">Mật khẩu mới</label>
                            <div className="admin-input-wrapper">
                                <FiLock className="admin-input-icon" />
                                <input
                                    id="al-password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Nhập mật khẩu mới"
                                    disabled={loading || success !== ''}
                                    onFocus={() => setFocusedField('password')}
                                    onBlur={() => setFocusedField(null)}
                                />
                                <button
                                    type="button"
                                    className="admin-toggle-password"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex="-1"
                                    disabled={loading || success !== ''}
                                >
                                    {showPassword ? <FiEyeOff /> : <FiEye />}
                                </button>
                            </div>
                        </div>

                        <div className={`admin-login-field ${focusedField === 'confirmPassword' ? 'is-focused' : ''} ${confirmPassword ? 'has-value' : ''}`}>
                            <label htmlFor="al-confirm-password">Xác nhận mật khẩu mới</label>
                            <div className="admin-input-wrapper">
                                <FiLock className="admin-input-icon" />
                                <input
                                    id="al-confirm-password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Nhập lại mật khẩu mới"
                                    disabled={loading || success !== ''}
                                    onFocus={() => setFocusedField('confirmPassword')}
                                    onBlur={() => setFocusedField(null)}
                                />
                                <button
                                    type="button"
                                    className="admin-toggle-password"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    tabIndex="-1"
                                    disabled={loading || success !== ''}
                                >
                                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className={`admin-login-button ${loading ? 'is-loading' : ''}`}
                            disabled={loading || success !== ''}
                            style={{ marginTop: '0.8rem' }}
                        >
                            {loading ? (
                                <>
                                    <span className="admin-login-spinner" />
                                    <span>Đang xử lý...</span>
                                </>
                            ) : (
                                <span>Đổi Mật Khẩu</span>
                            )}
                        </button>
                    </form>

                    {/* Footer */}
                    <div className="admin-login-footer">
                        <span>Đã nhớ mật khẩu?</span>
                        <a href="/admin/auth/login">Quay lại đăng nhập</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminChangePassword;
